import React from "react";
import { Package, Sparkles, Wrench, Layers, Handshake } from "lucide-react";

export const TYPES = { materiel: "Matériel", prestation: "Prestation", forfait: "Forfait", pack: "Pack", location: "Location" };

export const DEFAULT_CATEGORIES = ["Son", "Lumière", "Structure", "Mobilier", "Vidéo", "Décoration", "Général"];

export const TYPE_META = {
  materiel: { icon: Package, cls: "bg-[#FF6A00]/12 text-[#FF6A00]", badge: "bg-[#FF6A00]/10 text-[#FF6A00] border-[#FF6A00]/25" },
  prestation: { icon: Sparkles, cls: "bg-blue-500/12 text-blue-400", badge: "bg-blue-500/10 text-blue-400 border-blue-500/25" },
  forfait: { icon: Wrench, cls: "bg-emerald-500/12 text-emerald-400", badge: "bg-emerald-500/10 text-emerald-400 border-emerald-500/25" },
  pack: { icon: Layers, cls: "bg-purple-500/12 text-purple-400", badge: "bg-purple-500/10 text-purple-400 border-purple-500/25" },
  location: { icon: Handshake, cls: "bg-[#FFD500]/12 text-[#E6B800]", badge: "bg-[#FFD500]/10 text-[#E6B800] border-[#FFD500]/30" },
};

export const emptyItem = { name: "", type: "materiel", category: "Général", description: "", price: 0, total_quantity: 1, deposit_amount: 0, purchase_price: 0, location_id: "", locations: [], components: [], essentials: [], custom_fields: [], image: "", images: [], presentation_image: "", show_presentation_in_quote: false, supplier_id: "", supplier_cost: 0 };

export function Stat({ icon: Icon, label, value }) {
  return (
    <div className="rounded-xl border border-zinc-800 bg-zinc-900 p-3">
      <Icon className="h-4 w-4 text-zinc-500" />
      <p className="mt-1.5 text-xs text-zinc-500">{label}</p>
      <p className="font-display font-bold text-white">{value}</p>
    </div>
  );
}
